module.exports = __webpack_public_path__ + "img/register-bg.6e5c7285.jpg";